<template>
  <el-select
    :value="value"
    @input="change"
    filterable
    clearable
    placeholder="请选择项目名称">
    <el-option
      v-for="item in projects"
      :key="item.value"
      :label="item.name"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>

  export default {
    props:['value', 'projects'],
    watch: {
      projects:function(){
        if(this.projects.length > 0){
          this.$emit('input', this.projects[0].value)
          this.$emit('change', this.projects[0].value, this.projects[0].label)
        }
      }
    },
    methods: {
      change(value) {
        this.$emit('input', value)
        let project = this.projects.filter(project => project.value == value)
        if(project.length > 0){
          this.$emit('change', value, project[0].label)
        }else {
          this.$emit('change', '')
        }
      }
    }
  }
</script>